import { Table } from 'antd';
import styled from 'react-emotion/macro';
import { injectGlobal } from 'emotion';

import {
  width, height, space, color, fontSize, border, borderColor,
} from 'styled-system';

export const DCRPTabularWrapper = injectGlobal`
  .TabularWrapper {
    .ant-table-wrapper:first-child {
      display: none;
    }
  }
`;

const TableWrapper = styled(Table)` &&& {
  ${width}
  ${height}
  ${space}
  ${color}
  ${border}
  ${borderColor}
  text-transform: capitalize;
  
  table { 
    ${fontSize}
    
    td {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .ant-table-header {
    overflow: hidden;
    margin-bottom: 0 !important;
    width: calc(100% - 16px);
  }

  .ant-table-row {
    font-size: .98em;
    td {
     height: 5em;
    }
  }

  .ant-table-body {
    max-height: none !important;
  }

  .ant-spin-container, .ant-table-scroll, .ant-spin-nested-loading, .ant-table-small, .ant-table-content{
    height: 100%;
  }

  .ant-table-scroll {
    overflow: initial;
  }

  .ant-table-column-has-actions, .ant-table-column-has-filters, .ant-table-column-has-sorters {
    height: 5em;
  }

  
}`;

export default TableWrapper;
